<template>
    <div class="intro">
        <h2>关于一匠</h2>
        <p class="intro-desc">{{about.title}}</p>
        <p v-html="about.content"></p>
        <!--<p></p>-->
	</div>
</template>

<script>
export default {
    name: 'Intro',
    props: {
        about: Object
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .intro
        padding: 12% 5% 5%
        background: url('../../static/images/m_home_intro.png')
        color: #fff
        border-top: 0.01rem solid #fff
        h2
            display:inline-block
            position: relative
            font-size: 0.6rem
            font-weight: 1000
            margin-bottom: 1em
            &:after
                position: absolute
                display: block
                content: ''
                bottom: 0.05rem
                right: -0.4em
                width: 0.8em
                height: 0.14em
                background: $yellow
                border-radius: 0.05em
                opacity: 0.8
        .intro-desc
            font-size: 0.3rem
            font-weight:1000
            margin: 2em 0 1em
            word-wrap: break-word
        p
            font-size: 0.3rem
            line-height: 1.5em
            margin-bottom: 1em
</style>



// WEBPACK FOOTER //
// src/components/mobile/HomeAbout.vue